import GalleryIcon from '@/common/assets/icons/galleryIcon.svg?react';
import RollingLoadingIcon from '@/common/assets/icons/rollingLoadingIcon.svg?react';
import CameraIcon from '@/common/assets/icons/simpleDocumentCameraIcon.svg?react';
import UploadIcon from '@/common/assets/icons/uploadImage.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import UploadDocumentCameraPage from '@/common/components/camera/pages/UploadDocumentCameraPage';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { UploadImageCardPropsType } from '@/common/components/uploadImage/UploadImage.type';
import useModal from '@/common/hooks/useModal';
import { useState } from 'react';
import { Box, Flex } from 'styled-system/jsx';
import { gridItem } from 'styled-system/patterns';
import { token } from 'styled-system/tokens';

const UploadImageCard = ({
  title,
  imageData,
  onUploadImage,
  onEditImage,
  onDeleteImage,
  deleteImageLoading,
  uploadImageLoading,
  selectFromGallery = false,
  imagesIsShowOnly = false,
  photoRotate,
}: UploadImageCardPropsType) => {
  const { closeModal, open, openModal } = useModal();
  const [loading, setLoading] = useState(false);
  const {
    closeModal: galleryOrCameraCloseModal,
    open: galleryOrCameraOpen,
    openModal: galleryOrCameraOpenModal,
  } = useModal();
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setLoading(true);

    const file = event.target.files?.[0];

    if (!file) {
      setLoading(false);
      return;
    }

    try {
      const bitmap = await createImageBitmap(file);

      const canvas = document.createElement('canvas');

      canvas.width = bitmap.width;
      canvas.height = bitmap.height;

      const ctx = canvas.getContext('2d');

      if (!ctx) {
        bitmap.close();
        setLoading(false);
        return;
      }

      ctx.drawImage(bitmap, 0, 0);

      bitmap.close();

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            setLoading(false);
            return;
          }

          const compressedFile = new File(
            [blob],
            `${file.name.replace(/\.[^/.]+$/, '')}.jpg`,
            {
              type: 'image/jpeg',
              lastModified: Date.now(),
            },
          );

          const url = URL.createObjectURL(compressedFile);

          onUploadImage({
            imageData: {
              blob: compressedFile,
              url,
            },
            closeModal,
          });

          galleryOrCameraCloseModal();
          setLoading(false);
        },
        'image/jpeg',
        0.8,
      );
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  return (
    <Box
      backgroundColor="white"
      borderRadius="8px"
      className={gridItem({ rowSpan: 1 })}
    >
      {imageData?.image ? (
        <ImageCard
          imageData={{ name: imageData.title.fa_const, src: imageData.image }}
          extension={
            imagesIsShowOnly
              ? undefined
              : {
                  type: 'moreItems',
                  items: [
                    'editPhoto',
                    'downloadPhoto',
                    'retakePhoto',
                    'deletePhoto',
                  ],
                  handleClick: {
                    onEditSuccess: ({ data, closeModal }) => {
                      onEditImage?.({ imageData: data, closeModal });
                    },
                    retakePhotoOnClick: openModal,
                    deletePhotoOnClick: ({ closeModal: closeDeleteModal }) => {
                      onDeleteImage?.({
                        closeModal: () => {
                          closeDeleteModal();
                          closeModal();
                        },
                      });
                    },
                  },
                  deleteImageLoading: deleteImageLoading,
                }
          }
        />
      ) : (
        <>
          <Flex
            onClick={
              uploadImageLoading
                ? undefined
                : selectFromGallery
                  ? galleryOrCameraOpenModal
                  : openModal
            }
            justifyContent="center"
            alignItems="center"
            height="112px"
          >
            {uploadImageLoading ? (
              <RollingLoadingIcon width={60} />
            ) : (
              <UploadIcon />
            )}
          </Flex>
          <Flex
            h="40px"
            borderTop="1px solid"
            borderColor="gray-3"
            justifyContent="center"
            alignItems="center"
          >
            <Typography color="black-1" textStyle="b4">
              {title}
            </Typography>
          </Flex>
        </>
      )}
      {open && (
        <UploadDocumentCameraPage
          photoRotate={photoRotate}
          onDenyCamera={() => {}}
          updateImage={(img) => onUploadImage({ imageData: img, closeModal })}
          closeCamera={closeModal}
        />
      )}
      {galleryOrCameraOpen ? (
        <MainModal
          open={galleryOrCameraOpen}
          closeModal={loading ? () => {} : galleryOrCameraCloseModal}
        >
          {loading ? (
            <Flex
              position={'fixed'}
              top={0}
              left={0}
              right={0}
              bottom={0}
              backgroundColor={'#c2c2c2c8'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <CircularLoading color="colors.purple-primary" />
            </Flex>
          ) : null}
          <Flex justifyContent="space-evenly" gap="16px">
            <Flex
              flexDirection="column"
              alignItems="center"
              gap="8px"
              onClick={() => {
                openModal();
                galleryOrCameraCloseModal();
              }}
            >
              <CustomIcon
                backgroundColor="green-4"
                width={60}
                height={60}
                borderColor="green-2"
              >
                <CameraIcon stroke={token('colors.green-2')} />
              </CustomIcon>
              <Typography textStyle="b4" color="black-1">
                عکس برداری
              </Typography>
            </Flex>
            <label htmlFor="upload-from-gallery">
              <Flex flexDirection="column" alignItems="center" gap="8px">
                <CustomIcon
                  backgroundColor="purple-6"
                  width={60}
                  height={60}
                  borderColor={'purple-primary'}
                >
                  <GalleryIcon color={token('colors.purple-primary')} />
                </CustomIcon>
                <Typography textStyle="b4" color="black-1">
                  گالری
                </Typography>
                <input
                  onChange={handleFileChange}
                  id="upload-from-gallery"
                  type="file"
                  accept="image/*"
                  hidden
                />
              </Flex>
            </label>
          </Flex>
        </MainModal>
      ) : null}
    </Box>
  );
};
export default UploadImageCard;
